import { useNavigate, useParams } from "react-router-dom";
import { getMainUrl } from "../../shared/consts";
import { useDispatch } from "react-redux";
import { togglePaymentModal } from "../../store/slices/modalsSlice";

export const useCloseAutonomousCheckout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { zoneId = "", storeKey = "" } = useParams();

  const closeSession = () => {
    dispatch(togglePaymentModal({ open: false, args: null }));
    navigate(getMainUrl({ zoneId, storeKey, mode: "autonomous" }));
  };

  return closeSession;
};
